function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2 4C30.5 4 26.12 7.76 24 9.89 21.88 7.76 17.49 4 12.8 4 4.8 4 0 8.77 0 16.76c0 6.55 5.9 12.02 6.1 12.2l16.5 16.31c.78.77 2.02.77 2.8 0l16.47-16.25C42.1 28.78 48 23.3 48 16.76 48 8.77 43.2 4 35.2 4z"
})));